import { lazy } from "react";
import Loadable from "app/components/Loadable";
import Zoning from "./Zoning";

const zoning = Loadable(lazy(() => import("./Zoning")));

const zoningRoute = [{ path: "/zoning", element: <Zoning /> }];
export default zoningRoute;
